var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000"},React.createElement("path",{"d":"M1197.825 1283.15L1206.825 1292.15 1197.825 1301.15","transform":"translate(-1192 -1287) matrix(0 1 1 0 -89.825 89.825)"}))));
}

ChevronDown.defaultProps = {"width":"20","height":"10","viewBox":"0 0 20 10"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
